import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import classnames from 'classnames2';
import React, { forwardRef } from 'react';
import * as buttonStyles from './Button.scss';

var ButtonComp = function ButtonComp(_ref, ref) {
  var _classnames, _classnames2;

  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'button' : _ref$as,
      ariaLabel = _ref.ariaLabel,
      _ref$buttonType = _ref.buttonType,
      buttonType = _ref$buttonType === void 0 ? 'button' : _ref$buttonType,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      children = _ref.children,
      dataTest = _ref.dataTest,
      disabled = _ref.disabled,
      href = _ref.href,
      loading = _ref.loading,
      onClick = _ref.onClick,
      selected = _ref.selected,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'default' : _ref$size,
      title = _ref.title,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'neutral' : _ref$variant,
      rest = _objectWithoutProperties(_ref, ["as", "ariaLabel", "buttonType", "className", "children", "dataTest", "disabled", "href", "loading", "onClick", "selected", "size", "title", "variant"]);

  var isDisabled = disabled || loading;
  var stylesMap = classnames((_classnames = {}, _defineProperty(_classnames, className, className), _defineProperty(_classnames, buttonStyles.stateLoading, loading), _defineProperty(_classnames, buttonStyles.stateDisabled, disabled), _defineProperty(_classnames, buttonStyles.stateSelected, selected), _defineProperty(_classnames, buttonStyles.variantNeutral, variant === 'neutral'), _defineProperty(_classnames, buttonStyles.variantPrimary, variant === 'primary'), _defineProperty(_classnames, buttonStyles.variantDestructive, variant === 'destructive'), _defineProperty(_classnames, buttonStyles.variantNaked, variant === 'naked'), _defineProperty(_classnames, buttonStyles.sizeDefault, size === 'default'), _defineProperty(_classnames, buttonStyles.sizeSmall, size === 'small'), _defineProperty(_classnames, buttonStyles.sizeLarge, size === 'large'), _classnames));
  var childrenContainerStyleMap = classnames((_classnames2 = {}, _defineProperty(_classnames2, buttonStyles.buttonChildrenContainerVisible, !loading), _defineProperty(_classnames2, buttonStyles.buttonChildrenContainerNotVisible, loading), _classnames2));
  var HtmlElement = as;
  return React.createElement(HtmlElement, Object.assign({
    ref: ref,
    title: title,
    type: as === 'button' ? buttonType : null,
    "data-test": dataTest,
    className: stylesMap,
    onClick: as === 'button' && !isDisabled ? onClick : null,
    href: as === 'a' ? href : null,
    disabled: isDisabled,
    "aria-busy": loading,
    "aria-label": loading ? 'Loading' : ariaLabel,
    "aria-pressed": selected
  }, rest), loading && React.createElement("div", {
    "data-test": "loading-animation",
    "aria-hidden": true,
    className: buttonStyles.loadingAnimation
  }), React.createElement("div", {
    className: childrenContainerStyleMap
  }, children));
}; // Please delete once Voltron and Zeus are on the same version of typescript and use
// export const Button = forwardRef((props, ref) => ...


export var ButtonRefWrap = function ButtonRefWrap() {
  return forwardRef(ButtonComp);
};
export var Button = ButtonRefWrap();
export var ButtonDefaultProps = {
  buttonType: 'button'
}; // DO NOT export this in the public API, it is being exported for INTERNAL reuse ONLY - CL

export function createButton() {
  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  var ButtonBaseWithRef = function ButtonBaseWithRef(props, ref) {
    var _ref2, _classnames3;

    var disabled = props.disabled || props.loading;
    var stylesMap = classnames.apply(void 0, [(_ref2 = {}, _defineProperty(_ref2, buttonStyles.stateLoading, props.loading), _defineProperty(_ref2, buttonStyles.stateDisabled, props.disabled), _defineProperty(_ref2, buttonStyles.stateSelected, props.selected), _ref2)].concat(styles));
    var childrenContainerStyleMap = classnames((_classnames3 = {}, _defineProperty(_classnames3, buttonStyles.buttonChildrenContainerVisible, !props.loading), _defineProperty(_classnames3, buttonStyles.buttonChildrenContainerNotVisible, props.loading), _classnames3));
    return React.createElement("button", {
      tabIndex: props.tabIndex,
      title: props.title,
      type: props.buttonType || 'button',
      "data-test": props.dataTest,
      className: stylesMap,
      onClick: disabled ? null : props.onClick || null,
      disabled: disabled,
      ref: ref,
      "aria-busy": props.loading,
      "aria-label": props.loading ? 'Loading' : undefined,
      "aria-pressed": props.selected
    }, props.loading && React.createElement("div", {
      "data-test": "loading-animation",
      "aria-hidden": true,
      className: buttonStyles.loadingAnimation
    }), React.createElement("div", {
      className: childrenContainerStyleMap
    }, props.children));
  };

  return React.forwardRef(ButtonBaseWithRef);
}

function createButtonNamespace(buttonStyle) {
  var DefaultButton = createButton(buttonStyle, buttonStyles.sizeDefault);
  return Object.assign(DefaultButton, {
    Default: DefaultButton,
    Large: createButton(buttonStyle, buttonStyles.sizeLarge),
    Small: createButton(buttonStyle, buttonStyles.sizeSmall)
  });
}

export var ButtonDestructive = createButtonNamespace(buttonStyles.variantDestructive);
export var ButtonNaked = createButtonNamespace(buttonStyles.variantNaked);
export var ButtonNeutral = createButtonNamespace(buttonStyles.variantNeutral);
export var ButtonPrimary = createButtonNamespace(buttonStyles.variantPrimary);